<script lang="ts">
    import { _ } from "svelte-i18n";
    import type { ModelInfoManager } from "./ModelInfoManager";
    import Score from "../../Score.svelte";

    export let manager: ModelInfoManager;
    let modelTranslationKeyStore = manager.getModelTranslationKeyStore();
    const modelData = manager.getModelDataStore();
    let safetyScore: number = -1;
    modelData.subscribe((data) => {
        safetyScore = -1;
        if (
            typeof data?.properties !== "undefined" &&
            typeof data.properties["_score:bicycle:safety"] !== "undefined"
        ) {
            safetyScore =
                Math.round(
                    Number(data.properties["_score:bicycle:safety"]) * 10.0,
                ) / 10.0;
        }
    });
</script>

<div class="card-body p-4">
    <h3 class="mb-1">
        {$_(`${$modelTranslationKeyStore}.info.about.title`)}
    </h3>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.about.part1`)}
    </p>

    {#if safetyScore > -1}
        <div class="mx-3 mb-1 small text-muted safety">
            <div class="my-3">
                <Score score={safetyScore} class="score-main">
                    {safetyScore}
                </Score>
            </div>
            {$_(`${$modelTranslationKeyStore}.info.score`)}
        </div>
    {/if}

    <!-- <h3 class="mb-1">
        {$_(`${$modelTranslationKeyStore}.info.assumptions.title`)}
    </h3>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.assumptions.part1`)}
    </p> -->
</div>

<style>
    .safety {
        text-align: center;
    }
</style>
